<template>
  <div id="app">
    <router-view/>
    <vue-ins-progress-bar></vue-ins-progress-bar>
  </div>
</template>

<style src="./style.scss" lang="scss"></style>

<script>
export default {
  name: 'app',
  metaInfo: {
    title: 'Index',
    titleTemplate: '%s - مستشفى الطارق'
  },

  mounted () {
    // this.$insProgress.finish()
  },

  created () {
    this.$insProgress.start()

    this.$router.beforeEach((to, from, next) => {
      this.$insProgress.start()
      next()
    })

    this.$router.afterEach((to, from) => {
      this.$insProgress.finish()
    })
  },

  updated () {
    // Remove loading state
    setTimeout(() => document.body.classList.remove('app-loading'), 1)
    this.$insProgress.finish()
  }
}
</script>
